// Provides functionality to show/hide additional items in some list of items
// Expects following css classes:
//  'hide-more-container' on a wrapper along with 'hide-more-items' to hide initially
//  'hide-more-toggler' button or link to toggle and 'after-plus' or 'after-minus'
//  'hide-more' on the items to be affected
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.hide-more-toggler').forEach((el) => {
    el.addEventListener('click', (evt) => {
      let container = evt.currentTarget.closest('.hide-more-container');

      if (container.classList.contains('hide-more-items')) {
        container.classList.remove('hide-more-items');
        el.classList.remove('after-plus');
        el.classList.add('after-minus');
      }
      else {
        container.classList.add('hide-more-items');
        el.classList.remove('after-minus');
        el.classList.add('after-plus');
      }      
    })
  })
})